<template lang="pug">
q-dialog(ref="dialog" @hide="onDialogHide")
  q-card.q-dialog-plugin(style="width: 700px; max-width: 70vw;")
    q-card-section.bg-secondary.text-white
      .text-h6 Nahrání obrázku
    q-separator
    q-card-section

      q-input.q-my-md(label='Popisek obrázku' v-model="caption" required autofocus ref='caption'
        :rules="[$rules.required('Popisek obrázku je povinný'), $rules.minLength(3, 'Popisek musí být delší')]")

      q-uploader.full-width.uploader(ref="uploader" accept=".jpg,image/*" :factory="uploadFactory"
                 :hide-upload-btn="true" @uploaded="uploaded" @failed="failed")

    q-separator
    q-card-actions(align="right")
      q-btn(label="Storno" flat @click="onCancelClick")
      q-btn(color="primary" flat label="Nahrát" @click="onOKClick")
</template>
<style lang="stylus">
.uploader
  min-height 200px
</style>
<script>
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ValidationMixin } from 'components/edit/validation'

export default @Component({
  props: {
    initial: Object
  }
})
class AddImageDialog extends mixins(ValidationMixin) {
  caption = null

  show () {
    this.$refs.dialog.show()
  }

  hide () {
    this.$refs.dialog.hide()
  }

  onDialogHide () {
    this.$emit('hide')
  }

  uploadFactory (files) {
    return {
      formFields: [{
        name: 'caption',
        value: this.caption
      }],
      url: this.oarepo$.collectionItemModule.item.links.attachments
    }
  }

  async onOKClick () {
    const status = await this.validateRefs()
    if (!status) {
      this.notify$({ message: 'Opravte prosím chyby a zkuste znovu' })
      return
    }
    this.$refs.uploader.upload()
  }

  uploaded (info) {
    this.$emit('ok', JSON.parse(info.xhr.response))
    this.hide()
  }

  failed () {
    this.notify$({ message: 'Chyba při přenosu, zkuste znovu' })
  }

  onCancelClick () {
    this.hide()
  }
}
</script>
